import './instrument';
// Self-installing console ring-buffer for the feedback dialog — must load
// right after Sentry so it captures the rest of the app's module-eval logs.
import './utils/console_log_buffer';
import * as Sentry from '@sentry/react';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'antd'
import DashboardShell from './dashboard_shell.tsx'
import "./index.css";
import "./globals.css";
import "./offer_generation.css";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ShadCNThemeProvider } from './components/theme_provider.tsx';
import { initFirestore } from './firebase_config.ts';
import AuthPageWrapper from './routing/auth_page_wrapper.tsx';
import { AuthService } from './services/auth/auth_service.ts';
import { AntdThemeProvider } from './providers/antd_theme_provider.tsx';
import { setupChunkReloadOnPreloadError } from './utils/chunk_reload.ts';
import { AppErrorFallback } from './components/app_error_fallback.tsx';
import PublicShell from './routing/public_shell.tsx';
import { isPublicPath } from './routing/public_router.ts';
import moment from 'moment';
// Relativzeiten auf Deutsch (#200). Ohne diesen Import schreibt moment
// „a few seconds ago" statt „vor wenigen Sekunden" — die Bibliothek ist
// standardmäßig englisch und wurde hier nie lokalisiert. Alle übrigen
// moment-Aufrufe im Projekt formatieren numerisch (`DD.MM.YYYY`) oder rechnen
// (`diff`, `unix`, `isAfter`), sind also unberührt. `defineLocale` setzt die
// aktive Sprache bereits, der explizite Aufruf macht es nachlesbar.
//
// Bewusst `moment/dist/locale/de` statt `moment/locale/de`: die CJS-Variante
// bündelt Vites Dep-Optimizer mit einer EIGENEN moment-Kopie (150 KB Chunk mit
// vollständigem moment-Quelltext), die Sprache landet dann auf einer zweiten
// Instanz und die Oberfläche bleibt englisch. Die ESM-Variante importiert
// `../moment` und teilt sich damit die optimierte Instanz.
import 'moment/dist/locale/de';
moment.locale('de');
// Kalender beginnen am Montag (#206) — Begründung in der Datei.
import './dayjs_locale';

export const queryClient = new QueryClient()
//globalEventHandler.init();
// Recover from stale-deploy chunk 404s (REBAR-IQ-SUPERCHARGED-4): reload once
// to fetch fresh hashed assets instead of stranding the user on an error screen.
setupChunkReloadOnPreloadError();
initFirestore();
AuthService.getInstance();


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => <AppErrorFallback error={error} />}
    >
    <AntdThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ShadCNThemeProvider defaultTheme='dark'>
          <App>
            {isPublicPath(window.location.pathname) ? (
              // Public section (signed-link auth, e.g. the "Erfassung
              // starten" page from the AV forward mail) — no login, no
              // tenant selection. See routing/public_router.tsx.
              <PublicShell />
            ) : (
              <AuthPageWrapper>
                <DashboardShell />
              </AuthPageWrapper>
            )}
          </App>
        </ShadCNThemeProvider>
      </QueryClientProvider>
    </AntdThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)